import { render, staticRenderFns } from "./TabBills.vue?vue&type=template&id=68c29186&scoped=true&"
import script from "./TabBills.vue?vue&type=script&lang=js&"
export * from "./TabBills.vue?vue&type=script&lang=js&"
import style0 from "./TabBills.vue?vue&type=style&index=0&id=68c29186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c29186",
  null
  
)

export default component.exports